// Vendors
import React, { useState, useEffect } from 'react';
import moment from 'moment';

// Requests
import { getOrgFiles } from '../../requests';

const { organization } = window;

const OrganizationFiles = () => {
  const [orgFiles, setOrgFiles] = useState([]);
  const icon = type => {
    const doctypes = {
      mp4: 'file-video',
      pdf: 'file-pdf',
      jpg: 'file-image',
      exe: 'save',
      zip: 'file-archive',
      pptx: 'file-powerpoint',
      docx: 'file-word'
    };
    return <span className={`far fa-${doctypes[type]} u--padding-right-10`} />;
  };

  const handleSortChange = sortBy => {
    let files = orgFiles;

    switch (sortBy) {
      case 'alpha':
        files.sort((a, b) => {
          if (a.document_name.toLowerCase() < b.document_name.toLowerCase()) {
            return -1;
          } else if (
            a.document_name.toLowerCase() > b.document_name.toLowerCase()
          ) {
            return 1;
          } else {
            return 0;
          }
        });
        break;
      case 'date':
        files.sort((a, b) => {
          // 'b' first, so dates sort by most recent first
          return moment.utc(b.document.date).diff(moment.utc(a.document.date));
        });
        break;
    }
    return setOrgFiles([...files]);
  };

  useEffect(() => {
    getOrgFiles(organization.id).then(({ data }) => {
      setOrgFiles(data);
    });
  }, []);

  return (
    <div className="card">
      <div className="card__section org-file-list">
        {orgFiles && orgFiles.length ? (
          <>
            <div className="org-file-list__header">
              <h3>Files</h3>
              <div className="org-file-list__sorting">
                <div className="org-file-list__select-container">
                  <select
                    onChange={e => handleSortChange(e.currentTarget.value)}
                  >
                    <option>Sort By:</option>
                    <option value="alpha">Alphabetical</option>
                    <option value="date">Recently Added</option>
                  </select>
                </div>
              </div>
            </div>
            <ul className="org-file-list__ul">
              {orgFiles.map(({ document, document_name }) => (
                <li key={document.id} className="org-file-list__item">
                  <h5 className="org-file-list__title">{document_name}</h5>
                  <article className="card card--document">
                    <section className="card__body org-file-list__file-info">
                      <div>
                        {icon(document.subtype)}
                        <a href={document.url}>{document.filename}</a>
                        <div className="org-file-list__file-size">
                          File size:{' '}
                          <strong>{document.filesize_formatted}</strong>
                        </div>
                      </div>
                      <div className="org-file-list__upload-info">
                        <div>
                          Uploaded on: <strong>{document.date}</strong>
                        </div>
                        <div>
                          Uploaded by:{' '}
                          <strong>{document.author_displayname}</strong>
                        </div>
                      </div>
                    </section>
                  </article>
                </li>
              ))}
            </ul>
          </>
        ) : (
          'This organization does not have any documents.'
        )}
      </div>
    </div>
  );
};

export default OrganizationFiles;
